/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popExtraInvite.vue?vue&type=template&id=23fceb0e&scoped=true"
import script from "./popExtraInvite.vue?vue&type=script&lang=js"
export * from "./popExtraInvite.vue?vue&type=script&lang=js"
import style0 from "./popExtraInvite.vue?vue&type=style&index=0&id=23fceb0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fceb0e",
  null
  
)

export default component.exports